export function isEmpty(object: Object) {
    return (
        !isDefined(object) ||
        object &&
        Object.keys(object).length === 0 &&
        object.constructor === Object
    );
};

function isDefined(o: any) {
    return o !== undefined && o !== null;
}